import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

import { TableLoader } from "./FlexTable/Big/FlexTableStatelessComponents";

export const SWReactTableWrapperBox = styled.div<{ presentEmptyTable?: boolean }>`
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon["0"]};
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.midnight[600], 0.08)};
    ${({ presentEmptyTable }) => presentEmptyTable && `height:100%`};
`;

export const GhostLoader = (props: { rowNum?: number }) => (
    <SWReactTableWrapperBox>
        <TableLoader rowNum={props.rowNum} />
    </SWReactTableWrapperBox>
);
